<template>
  <main-template>
    <secondary-pages-background />
    <div class="p-privacy-policy p-other">
      <div class="container">
        <div class="content mb-xl">
          <h1 class="fs--medium fw--bold mb-xs">
            Политика конфиденциальности и обработки персональных данных пользователей Интернет-сайта ООО «КликТуАйДи»
          </h1>
          <div class="editor mb-l">
            <p>
              Общие положения
            </p>
            <p>
              Настоящая  Политика  определяет  порядок,  условия  обработки  персональных  данных  пользователей  Интернет-сайтаhttps://clicktoid.ru(далее -Сайт) и устанавливает требования по обеспечению безопасности персональных данных пользователей Администрацией Сайта.Политика разработана и реализуется в соответствии со следующими нормативными правовыми актами в области обработки и обеспечения безопасности персональных данных:Конституция Российской Федерации;Федеральный закон от 27.07.2006 N 152-ФЗ "О персональных данных";Постановление Правительства Российской Федерации от 15.09.2008 N 687 "Об утверждении Положения об особенностях обработки персональных данных, осуществляемой без использования средств автоматизации";Постановление Правительства Российской Федерации от 01.11.2012 N 1119 "Об утверждении требований к защите персональных данных при ихобработке в информационных системах персональных данных".Настоящая Политика принята и действует в Обществе с ограниченной ответственностью «КликТуАйДи», расположенном по адресу: 117133, г. Москва, ул Академика Варги, дом 8, к. 1, этаж 7, офис 703.(далее –«Компания»,«мы» или «АдминистрацияСайта»).
            </p>
            <p>
              В соответствии с настоящей Политикой мы обрабатываем и защищаем персональные данные, которые предоставляют нам зарегистрированные Пользователи и незарегистрированные посетители (далее –«Пользователи»или«Вы») Интернет-сайта https://clicktoid.ru, включающего полную и мобильную версии, а также мобильное приложение (далее –«CLICKTOID») с любого устройства и при коммуникации с нами в любой форме.Используя CLICKTOID и предоставляя нам свои персональные данные,Вы даете согласие на их обработку в соответствии с настоящей Политикой.Определения Конфиденциальность персональных данных – обязательное для выполнения лицом, получившим доступ к персональным данным, требование не передавать их третьим лицам без согласия субъекта персональных данных или иного законного основания.Персональные данные–любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (гражданину).
            </p>
            <p>
              Обработка персональных данных–любое действие с персональными данными, совершаемое с использованием средств автоматизации  или  без  использования  таких  средств.  К  таким  действиям  могут  относиться:  сбор,  получение,  запись, систематизация, накопление, хранение, обновление, изменение, извлечение, использование, передача (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных.Пользователь–физическое лицо, получающее доступ к функционалуИнтернет-сайта.Соглашениена  оказание  услуг  (оферта)–соглашение,  регулирующее  отношения,  возникающие  между  Компанией  и Пользователем при использовании CLICKTOID(доступно по ссылкеhttps://clicktoid.ru/agreement), и иные правила и документы опубликованные на CLICKTOID, регламентирующие работу CLICKTOIDили определяющие порядок использования Сервисов.Сервисы–функциональные возможности, службы, услуги, инструменты, доступные для Пользователей на CLICKTOID.Администрация Сайта/Компания–компания ООО "КликТуАйДи". Адрес: г. Москва, ул Академика Варги, дом 8, к. 1, этаж 7, офис 703.
            </p>
            <p>
              Обработка персональных данных Пользователей Сайта производится с соблюдением следующих принципов:законности;ограничения обработки персональных данных достижением конкретных, заранее определенных и законных целей;недопущения обработки персональных данных, несовместимой с целями сбора персональных данных;недопущения объединения баз данных,содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой.
            </p>
          </div>
          <app-button title="К другим соглашениям" description="Страница продуктов и соглашений" to="/agreements">
            <icon-arrow-right class="icon" />
          </app-button>
        </div>
      </div>
    </div>
  </main-template>
</template>

<script>
import MainTemplate from '@/layouts/MainTemplate'
import AppButton from '@/components/common/AppButton'
import SecondaryPagesBackground from '@/components/SecondaryPagesBackground'
import IconArrowRight from '@/assets/img/icons/arrow-right.svg'

export default {
  name: 'PrivacyPolicy',
  components: {
    MainTemplate,
    AppButton,
    SecondaryPagesBackground,
    IconArrowRight
  }
}
</script>

<style lang="scss" scoped>
  .p-privacy-policy {
    .content {
      max-width: 864px;
      padding: 16px;
      background: linear-gradient(180deg, rgba(250, 250, 250, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
      backdrop-filter: blur(12px);
      border-radius: $border-radius-large;
      .icon {
        transform: rotate(90deg);
      }
    }
  }
</style>